"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFieldSchemaComponent = void 0;
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const SchemaNavigationDefaultStrategy_1 = tslib_1.__importDefault(require("../../schema/SchemaNavigationDefaultStrategy"));
const SchemaConstants_1 = tslib_1.__importDefault(require("../../schema/SchemaConstants"));
class DateFieldSchemaComponent extends fmko_ts_widgets_1.HasValueWidget {
    constructor(args) {
        super();
        this.element = document.createElement("div");
        this.element.classList.add("date-field-schema-component");
        const { renderingContext, shouldDisplayWeekDay } = args;
        const { currentCell } = renderingContext;
        this.shouldDisplayWeekDay = shouldDisplayWeekDay;
        this.weekDaySpan = document.createElement("span");
        this.weekDaySpan.classList.add("week-day-span");
        this.dateField = new fmko_ts_widgets_1.WCAGDateField(args);
        fmko_ts_common_1.DOM.setElementTabbable(this.dateField.getFieldElement(), false);
        this.add(this.weekDaySpan);
        this.add(this.dateField);
        this.element.addEventListener("click", () => {
            this.dateField.getFieldElement().focus();
        });
        this.dateField.addValueChangeHandler(() => {
            fmko_ts_common_1.ValueChangeEvent.fire(this, this.getValue());
        });
        SchemaNavigationDefaultStrategy_1.default.addFieldElementListener({
            fieldElement: this.dateField.getFieldElement(),
            renderingContext
        });
        this.dateField.addDatePickerStatusChangedHandler(event => {
            const isOpen = event.getValue() === fmko_ts_widgets_1.DatePickerStatus.OPEN;
            currentCell.classList.toggle(SchemaConstants_1.default.NAVIGATION_BLOCKED, isOpen);
        });
    }
    focus() {
        this.dateField.focus();
        this.dateField.openDatePicker();
    }
    getValue() {
        return this.dateField.getValue();
    }
    setValue(newValue, fireEvents = false) {
        this.dateField.setValue(newValue, fireEvents);
        this.updateWeekDayText();
    }
    setEnabled(enabled) {
        this.dateField.setEnabled(enabled);
    }
    setShouldDisplayWeekDay(shouldDisplayWeekDay) {
        this.shouldDisplayWeekDay = shouldDisplayWeekDay;
        this.updateWeekDayText();
    }
    click() {
        this.focus();
    }
    onCellFocusKeyDown(event) {
        if (!this.isEnabled()) {
            return;
        }
        if (!this.dateField.isValidInputString(event.key)) {
            return;
        }
        this.clearValue();
        this.focus();
        this.dateField.simulateCharacterPressed(event);
    }
    isEnabled() {
        return this.dateField.isEnabled();
    }
    updateWeekDayText() {
        const date = this.dateField.getValue() ?? null;
        const shouldDisplay = this.shouldDisplayWeekDay && !!date;
        (0, fmko_ts_common_1.setElementVisible)(this.weekDaySpan, shouldDisplay);
        this.weekDaySpan.textContent = shouldDisplay && (0, fmko_ts_common_1.getWeekdayAsString)(date);
    }
}
exports.DateFieldSchemaComponent = DateFieldSchemaComponent;
//# sourceMappingURL=DateFieldSchemaComponent.js.map